<div class="header">
  <div class="header-left">
    <div class="header-left-content">
      <h2>Bed Setup Settings</h2>
      <div class="facility-select">
        <select [value]="selectedFacilityId ?? ''" (change)="onFacilityChange($any($event.target).value)">
          <option value="">-- Select Facility --</option>
          <option *ngFor="let f of facilityMaps" [value]="f.fac_id">
            {{ f.facility_name }} (FAC {{ f.fac_id }} / REG {{ f.regionId }} &mdash; {{ f.sum_beds }} beds)
          </option>
        </select>
      </div>

      <button class="board-btn" (click)="csvFileInput.click()">
        <i class="fa fa-upload"></i> Import CSV
      </button>
      <input #csvFileInput type="file" accept=".csv" multiple (change)="onFileSelected($event)" hidden />
    </div>
  </div>

</div>

<!-- Toolbar -->
<div class="toolbar" *ngIf="bedSetupData">
  <div class="toolbar-legend">
    <span class="legend-tile">
      <i class="fa fa-bed" style="color:#4a7ea8"></i>
      <span class="legend-count">{{ bedSetupData.sum_beds || 0 }}</span>
      <span class="legend-text">Beds</span>
    </span>
    <span class="legend-tile tile-green">
      <i class="fa fa-check-circle"></i>
      <span class="legend-count">{{ activeCount || 0 }}</span>
      <span class="legend-text">Active</span>
    </span>
    <span class="legend-tile tile-red">
      <i class="fa fa-ban"></i>
      <span class="legend-count">{{ notActiveCount || 0 }}</span>
      <span class="legend-text">Inactive</span>
    </span>
    <span class="legend-tile tile-purple">
      <i class="fa fa-home"></i>
      <span class="legend-count">{{ roomTypeCount || 0 }}</span>
      <span class="legend-text">Room Type</span>
    </span>
    <span class="legend-tile">
      <i class="fa fa-building" style="color:#4a7ea8"></i>
      <span class="legend-count">{{ bedSetupData.units?.length || 0 }}</span>
      <span class="legend-text">Units</span>
    </span>
  </div>

  <div class="toolbar-actions">
    <div class="sum-beds-input">
      <label>Sum Beds</label>
      <input type="number" [value]="bedSetupData.sum_beds" (change)="onSumBedsChange($any($event.target).value)" min="0" />
    </div>
    <button class="board-btn primary" (click)="openAddPopup()">
      <i class="fa fa-plus"></i> Add Bed
    </button>
    <button class="board-btn" (click)="exportCsv()">
      <i class="fa fa-download"></i> Export CSV
    </button>
  </div>
</div>

<!-- Messages -->
<div class="error-msg" *ngIf="error">{{ error }}</div>
<div class="success-msg" *ngIf="successMsg">{{ successMsg }}</div>

<!-- Loading -->
<div *ngIf="loading" class="loading-overlay">
  <div class="loading-spinner"></div>
  <span>Loading...</span>
</div>

<!-- Unit Cards -->
<div class="units-container" *ngIf="unitGroups?.length">
  <div class="unit" *ngFor="let g of unitGroups">
    <h2 *ngIf="editingUnitId !== g.unitId" (dblclick)="startUnitRename(g)">{{ g.unitName }}</h2>
    <h2 *ngIf="editingUnitId === g.unitId" class="unit-name-editing">
      <input type="text" [(ngModel)]="editingUnitName"
        (blur)="saveUnitRename(g)"
        (keydown.enter)="saveUnitRename(g)"
        (keydown.escape)="cancelUnitRename()"
        #unitNameInput />
    </h2>
    <div class="unit-bed-counter-container">
      <div class="unit-bed-counter">
        <span class="unit-bed-count-title"><i class="fa fa-bed"></i> Beds</span>
        <span class="unit-bed-count">{{ g.beds.length }}</span>
      </div>
      <div class="unit-bed-counter">
        <span class="unit-bed-count-title"><i class="fa fa-check-circle" style="color:#16a34a"></i> Active</span>
        <span class="unit-bed-count">{{ g.activeCount }}</span>
      </div>
      <div class="unit-bed-counter">
        <span class="unit-bed-count-title"><i class="fa fa-ban" style="color:#dc2626"></i> Inactive</span>
        <span class="unit-bed-count">{{ g.notActiveCount }}</span>
      </div>
    </div>

    <table>
      <colgroup>
        <col class="col-room">
        <col class="col-type">
        <col class="col-status">
        <col class="col-actions">
      </colgroup>
      <thead>
        <tr>
          <th><i class="fa fa-door-open"></i> R/B</th>
          <th><i class="fa fa-home"></i> Room Type</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bed of g.beds; let i = index"
          [class.room-border]="i + 1 < g.beds.length && g.beds[i + 1].room_number !== bed.room_number">

          <td (click)="openEditPopup(bed)" class="cell-clickable">
            <div class="room-bed">{{ bed.room_number }} - {{ bed.bed_desc }}</div>
          </td>

          <td>
            <span class="cell-text" *ngIf="editingBedId !== bed.bed_id || editingField !== 'room_type'"
              (click)="startInlineEdit(bed, 'room_type')"
              [class.empty-value]="!bed.room_type">
              {{ bed.room_type || '(none)' }}
            </span>
            <select *ngIf="editingBedId === bed.bed_id && editingField === 'room_type'"
              class="inline-select"
              [ngModel]="bed.room_type"
              (ngModelChange)="onRoomTypeChange(bed, $event); clearInlineEdit()"
              (blur)="clearInlineEdit()">
              <option *ngFor="let rt of roomTypes" [value]="rt">{{ rt || '(none)' }}</option>
            </select>
          </td>

          <td>
            <span class="cell-text" *ngIf="editingBedId !== bed.bed_id || editingField !== 'status'"
              (click)="startInlineEdit(bed, 'status')">
              <span class="status-badge" [ngClass]="'status-' + bed.status">
                <i class="fa" [ngClass]="bed.status === 'active' ? 'fa-check-circle' : 'fa-ban'"></i>
                {{ bed.status }}
              </span>
            </span>
            <select *ngIf="editingBedId === bed.bed_id && editingField === 'status'"
              class="inline-select" [ngClass]="'status-' + bed.status"
              [ngModel]="bed.status"
              (ngModelChange)="onStatusChange(bed, $event); clearInlineEdit()"
              (blur)="clearInlineEdit()">
              <option *ngFor="let s of statuses" [value]="s">{{ s }}</option>
            </select>
          </td>

          <td class="cell-actions">
            <div class="row-actions">
              <button class="delete-btn" (click)="deleteBedInline(bed)" title="Delete bed">
                <i class="fa fa-trash"></i>
              </button>
              <div class="row-menu-wrapper">
                <button class="menu-btn" (click)="toggleRowMenu(bed.bed_id, $event)" title="More actions">
                  <i class="fa fa-ellipsis-v"></i>
                </button>
                <div class="row-menu" *ngIf="activeRowMenu === bed.bed_id">
                  <button (click)="openDuplicateBedPopup(bed, $event)">
                    <i class="fa fa-arrow-up"></i> Add Row Above
                  </button>
                  <button (click)="openDuplicateBedPopup(bed, $event)">
                    <i class="fa fa-arrow-down"></i> Add Row Below
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="bedSetupData && !bedSetupData.beds?.length && !loading" class="no-data">
  No beds found for this facility. Import a CSV or add beds manually.
</div>

<!-- ========== POPUP OVERLAY ========== -->
<div class="popup-overlay" *ngIf="popupOpen" (click)="closePopup()">
  <div class="popup" (click)="$event.stopPropagation()">
    <!-- Edit Mode -->
    <ng-container *ngIf="popupMode === 'edit' && popupBed">
      <div class="popup-header">
        <h3><i class="fa fa-edit"></i> Edit Bed</h3>
        <button class="popup-close" (click)="closePopup()">&times;</button>
      </div>
      <div class="popup-body">
        <div class="popup-field readonly">
          <label>Unit</label>
          <span>{{ popupBed.unit_name }}</span>
        </div>
        <div class="popup-field readonly">
          <label>Room</label>
          <span>{{ popupBed.room_number }}</span>
        </div>
        <div class="popup-field readonly">
          <label>Bed</label>
          <span>{{ popupBed.bed_desc }}</span>
        </div>
        <div class="popup-field">
          <label><i class="fa fa-home" style="color:#6c3483"></i> Room Type</label>
          <input type="text" [(ngModel)]="editRoomType" placeholder="e.g. Private, Semi-Private, Ward..." />
        </div>
        <div class="popup-field">
          <label>Status</label>
          <select [(ngModel)]="editStatus">
            <option *ngFor="let s of statuses" [value]="s">{{ s }}</option>
          </select>
        </div>
        <div class="popup-field readonly bed-id-field">
          <label>Bed ID</label>
          <span>{{ popupBed.bed_id }}</span>
        </div>
      </div>
      <div class="popup-footer">
        <button class="board-btn danger" (click)="deleteBed()">
          <i class="fa fa-trash"></i> Delete
        </button>
        <div class="popup-footer-right">
          <button class="board-btn" (click)="closePopup()">Cancel</button>
          <button class="board-btn primary" (click)="saveEdit()">Save</button>
        </div>
      </div>
    </ng-container>

    <!-- Import Mode -->
    <ng-container *ngIf="popupMode === 'import'">
      <div class="popup-header">
        <h3><i class="fa fa-upload"></i> Import CSV Files</h3>
        <button class="popup-close" (click)="closePopup()">&times;</button>
      </div>
      <div class="popup-body">
        <div class="popup-field popup-field--inline">
          <label>Region ID</label>
          <span class="popup-field-badge">{{ importRegionId }}</span>
        </div>
        <div class="import-mode">
          <label class="import-mode__toggle">
            <input type="checkbox" role="switch" [attr.aria-checked]="importReplaceExisting"
                   [(ngModel)]="importReplaceExisting" />
            <span class="import-mode__switch" aria-hidden="true"></span>
            <span class="import-mode__label">
              <span class="import-mode__title">Replace existing beds</span>
              <span class="import-mode__subtitle">Delete beds that are not in the CSV</span>
            </span>
          </label>

          <div *ngIf="importReplaceExisting" class="import-mode__warning" role="alert">
            <svg class="import-mode__warning-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 9v4M12 17h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div>
              <div class="import-mode__warning-title">This will permanently delete beds</div>
              <div class="import-mode__warning-body">
                Any bed in the database that is not present in the CSV will be removed.
                Turn this off to merge only (insert new + update existing).
              </div>
            </div>
          </div>
        </div>
        <div class="import-file-list">
          <label>Files to import:</label>
          <div class="import-file-item" *ngFor="let f of importFiles">
            <i class="fa fa-file-csv" style="color:#16a34a"></i>
            <span class="import-file-name">{{ f.fileName }}</span>
            <span class="import-file-fac">fac_id: <strong>{{ f.fac_id || '?' }}</strong></span>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <div></div>
        <div class="popup-footer-right">
          <button class="board-btn" (click)="closePopup()">Cancel</button>
          <button class="board-btn primary"
                  (click)="runImport()"
                  [disabled]="!canRunImport()"
                  [title]="canRunImport() ? '' : 'All files must have a valid fac_id_<N> in their filename'">
            <i class="fa fa-upload"></i> Import {{ importFiles.length }} file{{ importFiles.length > 1 ? 's' : '' }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- Add Mode -->
    <ng-container *ngIf="popupMode === 'add'">
      <div class="popup-header">
        <h3><i class="fa fa-plus"></i> Add New Bed</h3>
        <button class="popup-close" (click)="closePopup()">&times;</button>
      </div>
      <div class="popup-body">
        <div class="popup-field">
          <label>Unit Name</label>
          <input type="text" [(ngModel)]="newBed.unit_name" placeholder="e.g. Long Hall" />
        </div>
        <div class="popup-field">
          <label>Room Number</label>
          <input type="text" [(ngModel)]="newBed.room_number" placeholder="e.g. 119" />
        </div>
        <div class="popup-field">
          <label>Bed Desc</label>
          <input type="text" [(ngModel)]="newBed.bed_desc" placeholder="e.g. D" />
        </div>
      </div>
      <div class="popup-footer">
        <div></div>
        <div class="popup-footer-right">
          <button class="board-btn" (click)="closePopup()">Cancel</button>
          <button class="board-btn primary" (click)="addBed()">
            <i class="fa fa-plus"></i> Add
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
